import { useEffect, useState } from 'react';
import supabase from 'modules/core/supabase/supabase';
import { mapVideoMarkerDto } from 'modules/video-markers/domain/data-mappers';
import { VideoMarker } from 'modules/video-markers/domain/interfaces';

export interface MatchVideoMarkersState {
  markers: VideoMarker[];
  isLoading: boolean;
  /** Чтение упало — для экрана это то же «меток нет», но причину видно в консоли. */
  isError: boolean;
}

const EMPTY: VideoMarker[] = [];

/**
 * Все строки `video_markers` матча — любых программ, меток и опорных точек. Читаются один раз на
 * матч: после матча строк больше не прибавляется, а экран «Моментов» открывают уже после него.
 */
export function useMatchVideoMarkers(matchId: number | null | undefined): MatchVideoMarkersState {
  const [state, setState] = useState<MatchVideoMarkersState>({ markers: EMPTY, isLoading: !!matchId, isError: false });

  useEffect(() => {
    if (!matchId) {
      setState({ markers: EMPTY, isLoading: false, isError: false });
      return;
    }

    let cancelled = false;
    setState({ markers: EMPTY, isLoading: true, isError: false });

    supabase.videoMarkers.listByMatch(matchId).then(
      (rows) => {
        if (!cancelled) setState({ markers: rows.map(mapVideoMarkerDto), isLoading: false, isError: false });
      },
      (error) => {
        console.error('Не удалось прочитать видеометки матча', error);
        if (!cancelled) setState({ markers: EMPTY, isLoading: false, isError: true });
      },
    );

    return () => {
      cancelled = true;
    };
  }, [matchId]);

  return state;
}
